import notification from './notification';

import ErrorResponse from '../api/types/ErrorResponse';

const errorResponseNotification = (response: ErrorResponse) => {
	response.errors.forEach((error) => {
		notification('error', error.title, error.detail);
	});
};

export default errorResponseNotification;
